module.exports = __webpack_public_path__ + "d704bb3d579b7d5e40880c75705c8a71.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-100italic.woff
// module id = 658
// module chunks = 0